'use strict';

import React, { Component } from 'react';
import {IMG_URL} from '../img/hosted_images'

class StatusContainer extends Component {
  constructor(props) {
    super(props);
    this.getStatusText = this.getStatusText.bind(this);
  }

  renderIcon() {
    const isString = typeof(this.props.icon) === 'string';
    return (
      <div className="card-icon">
        {!isString && this.props.icon}
      </div>
    );
  }

  getStatusText(status) {
    switch (status) {
      case 'online': return 'We\'re online!';
      case 'offline': return 'Leave us a message';
      case 'away': return 'We\'re away!';
      default: return 'Connecting...';
    }
  }

  render() {
    return (
      <div className="status-container">
        {/* {this.getStatusText(this.props.accountStatus)} */}
        <div className="header-image">
          <img src={IMG_URL + '/riverty-logo.svg'} alt="client logo" />
        </div>
        <div className="header-button minimize-button" onClick={this.props.minimizeOnClick}>
          <div className="minimize-button-bar">&#9866;</div>
        </div>
        <div className="header-button" onClick={this.props.endChatButtonClick}>
          <div className="close-button-bar">&times;</div>
        </div>
      </div>
    );
  }
}

StatusContainer.displayName = 'StatusContainer';
StatusContainer.propTypes = {
  accountStatus: React.PropTypes.string,
  minimizeOnClick: React.PropTypes.func,
  endChatButtonClick: React.PropTypes.func
}
export default StatusContainer;



// WEBPACK FOOTER //
// ./src/components/StatusContainer.js